<template>
    <!--页面头部-->
    <div class="page-title" :style='styleCpt'>
        <p class="">
            <span>{{pageName}}</span>
            <span v-if="fundCode"> - </span>
            <span v-if="fundCode">{{fundCode}}</span>
        </p>
    </div>
</template>
<script>
    export default {
        props:['pageName','fundCode','styleCpt']
    }
</script>




// WEBPACK FOOTER //
// src/components/BaseCpts/pageTitle.vue